const Pagination = ({ visiblePages, current_page, handlePageClick }) => {
  if (!visiblePages || visiblePages.length === 0) return null;

  return (
    <div style={{ margin: "20px 10px", textAlign: "center" }}>
      {visiblePages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={index}
            onClick={() => handlePageClick(page)}
            style={{
              margin: "0 5px",
              padding: "5px 5px",
              fontSize: "16px",
              fontWeight: page === current_page ? 900 : "normal",
              backgroundColor: "#FFFFFF",
              border: "none",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            {page}
          </button>
        ) : (
          <span
            key={index}
            style={{
              margin: "0 5px",
              padding: "5px 10px",
              color: "#999999",
              cursor: "default",
            }}
          >
            {page}
          </span>
        )
      )}
    </div>
  );
};

export default Pagination;
